module.exports = __webpack_public_path__ + "vue_assets/img/img_footer_background.4e899ced.png";